import {useEffect, useState} from "react";
import {CheckCircle} from "react-feather";
import {Alert, Badge, Button, Col, Input, Row} from "reactstrap";
import {CopyToClipboard} from "react-copy-to-clipboard/lib/Component";
import {toast} from "react-toastify";
import AtomToast from "@atoms/toastify/AtomToast";
import {getInfoReferral, getMyBalance} from "@store/actions/withdrawal";
import {useDispatch, useSelector} from "react-redux";
import alert from "@src/utility/Alert";
import AtomPageLoader from "@atoms/PageLoader";
import {toRupiah} from "@src/services/utils/commonHelper";
import AtomReferralGenerate from "@src/views/referral/AtomReferralGenerate";

const ReferralInfo = ({stepper, id, loadSection}) => {
    const dispatch = useDispatch();
    const {
        info, balance
    } = useSelector((state) => state.withdrawal);
    const [isFetch, setIsFetch] = useState(false);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        (async () => {
            if(id === loadSection) {
                try {
                    setIsFetch(false);
                    setLoading(true);
                    await dispatch(getInfoReferral());
                    await dispatch(getMyBalance());
                } catch (error) {
                    alert.error(error.message);
                } finally {
                    setLoading(false);
                    setIsFetch(true);
                }
            }
        })();
    }, [loadSection]);

    const onCopy = () => {
        toast.success(<AtomToast title={"Tersalin"} color={"success"} content={"Data tersalin"} icon={<CheckCircle/>} />, {
            autoClose: 3000,
            hideProgressBar: true,
            closeButton: false
        })
    }

    return (
        <>
            {loading ? <AtomPageLoader/> :
                <>
                <Badge color="primary" className={"mb-2"}>Kode referral</Badge>
                <Row>
                    {info === null ?
                    <AtomReferralGenerate/> :
                    <>
                        <Col xl='2' md='2' sm='6' className='pr-sm-0 mb-md-0 mb-1'>
                            <Input type={"text"} readOnly value={info.code} />
                        </Col>
                        <Col md='2' sm='12'>
                            <CopyToClipboard onCopy={onCopy} text={info.code}>
                                <Button color='primary' outline>
                                    Salin Kode
                                </Button>
                            </CopyToClipboard>
                        </Col>
                        <Col xl='6' md='6' sm='6' className='pr-sm-0 mb-md-0 mb-1'>
                            <Input type={"text"} readOnly value={"https://portal.bisapppk.com/auth/register?reff=" + info.code} />
                        </Col>
                        <Col md='2' sm='12'>
                            <CopyToClipboard onCopy={onCopy} text={"https://portal.bisapppk.com/auth/register?reff=" + info.code}>
                                <Button color='primary' outline>
                                    Salin Link
                                </Button>
                            </CopyToClipboard>
                        </Col>
                        <Col sm={12} className={"mt-4"}>
                            <Alert color='primary'>
                                <div className='alert-body'>
                                    <p className={"font-weight-bold"}>Ketentuan : </p>
                                    <p>1. Setiap pembelian paket 3-bulan menggunakan kode referral kamu, kamu akan mendapatkan fee komisi sebesar Rp15,000 per penjualan</p>
                                    <p>2. Setiap pembelian paket 12-bulan menggunakan kode referral kamu, kamu akan mendapatkan fee komisi sebesar Rp25,000 per penjualan</p>
                                    <p>3. Minimal penarikan Rp50,000 per penarikan</p>
                                    <p>4. Request penarikan hanya bisa 1x sampai status penarikan sudah tidak lagi "waiting verification", setelah status penarikan "completed" atau "rejected" dapat melakukan penarikan lagi</p>
                                </div>
                            </Alert>
                        </Col>
                        <Col sm={12} className={"mt-4 text-center"}>
                            <h3 className={"text-center text-black-50"}>Saldo Saya</h3>
                            <h1 className={"text-center text-black-50"}>{toRupiah(balance)}</h1>

                            <a href={"https://bit.ly/3Hst3a1"} target={"_blank"}>
                                <Button className="mt-2 rounded mr-2" color='info'  outline>
                                    Download Marketing Kit
                                </Button>
                            </a>
                            <Button className="mt-2 rounded" color='success' outline onClick={() => stepper.next()}>
                                Penarikan
                            </Button>
                        </Col>
                    </>}
                </Row>
            </>}
        </>
    )
}

export default ReferralInfo